<template>
  <div id="main">
    <h2>{{$t('meeting.duplicate.title',{name:row.name})}}</h2>
    <form id='formDuplicate'>
      <span>
        <label for="duplicateName">{{$t('board.creation.label.nom')}} : </label>
        <b-input
          id="duplicateName"
          v-model="rowDuplicate.name"
          name="duplicateName"
          @focus="$event.target.select()"
        />
      </span>
      <b-checkbox
        v-if="outil === 'brainstormin'"
        v-model="parameters.brainKeepPostits"
      >{{ $t('duplicate.parameter.brain.post-its') }}</b-checkbox>

      <b-checkbox
        v-if="outil === 'brainstormin'"
        v-model="parameters.brainKeepLinks"
      >{{ $t('duplicate.parameter.brain.links') }}</b-checkbox>

      <div class="popup-footer">
        <button
          @click.prevent="$parent.close()"
          class="button"
        >{{ $t('button.annuler') }}</button>
        <button
          @click.prevent="duplicateMeeting"
          type="is-success"
          class="is-success button"
        >{{ $t('button.validate') }}</button>
      </div>
    </form>
    <!-- <b-loading
      is-primary
      is-full-page
      :active.sync="isLoading"
    ></b-loading> -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'PopupDuplicate',
  data () {
    return {
      isLoading: false,
      parameters: {
        eventKeepAttendees: false,
        eventKeepEvents: false,
        sondKeepAnswers: false,
        sondKeepQuestions: false,
        quizzKeepAnswers: false,
        quizzKeepQuestions: false,
        proKeepInventory: false,
        textKeepQuestions: false,
        brainKeepPostits: false
      },
      rowDuplicate: JSON.parse(JSON.stringify(this.row))
    }
  },
  props: {
    outil: String,
    row: Object
  },
  created () {
    let date = new Date()
    this.rowDuplicate.name = `${this.rowDuplicate.name} (${this.$i18n.t('meeting.duplicate.rename')} ${date.getDate()}/${date.getMonth() + 1} ${date.getHours()}:${date.getMinutes()})`
  },
  methods: {
    duplicateMeeting () {
      this.isLoading = true
      this.parameters.row = this.rowDuplicate
      axios
        .post(
          `${process.env.URL_SSO_API}Duplicate/${this.outil}/${this.rowDuplicate.url_moderateur}`,
          this.parameters
        )
        .then(response => {
          this.$parent.close()
          this.$store.dispatch('auth/setInitSearch')
          this.$parent.$parent.rechercheBoard = ''
          this.$store.dispatch('board/listAvailaible')
          this.isLoading = false
          this.$buefy.toast.open({
            type: 'is-success',
            message: this.$i18n.t('meeting.duplicate.success')
          })
        })
    }
  }
}
</script>

<style scoped>
#main {
  background-color: white;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  min-height: 200px;
  display: flex;
  flex-flow: column wrap;
}

#formDuplicate > * {
  margin: 5px;
  width: 330px;
}

.submit_button {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
  background-color: #23d160;
  color: white;
}

#formDuplicate {
  display: flex;
  flex-flow: column wrap;
  padding: 10px;

  align-content: space-around;
}

h2 {
  font-weight: 600;
  padding: 10px;
}

.popup-footer {
  padding: 1.5em 0;
  display: flex;
  justify-content: center;
}

.popup-footer * {
  width: 100px;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/PopupDuplicate.vue